export default __webpack_public_path__ + "static/media/03-datagrid-min.ed8bb20b.png";